<template>
  <form @submit.prevent="submit">
    <div id="app" class="container">
      <section class="mb-6">
        <b-field label="Name">
          <b-input type="text"
                   maxlength="30"
                   :disabled="disable"
                   v-model="form.name">
          </b-input>
        </b-field>

        <b-field label="Description">
          <textarea
            class="textarea"
            style="resize: none"
            v-model="form.description"
            maxlength="250"
          ></textarea>
        </b-field>
      </section>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    vendor: {
      type: Object,
      default: null
    },
    disable: {
      type: Boolean,
      default: null
    }
  },

  data() {
    return {
      form: new window.Form({
        id: this.vendor ? this.vendor.id : null,
        name: this.vendor ? this.vendor.name : null,
        description: this.vendor ? this.vendor.description : null,
        magazines: this.vendor ? this.vendor.magazine : [],
      }),
    };
  },

  methods: {
    load() {
      let status =
        this.$route.query.status === "all" ? null : this.$route.query.status;

      let country =
        this.$route.query.country === "all" ? null : this.$route.query.country;

      this.vendors.filter({status, country}).changePage(1);
    },
    submit() {
      if (this.vendor) {
        this.form.put(`/admin/api/wifi/vendors/${this.vendor.id}`).then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: "Successfully saved."
          });
          this.form.id = null;
          this.form.name = null;
          this.form.description = null;

          this.whenAdded();
        });
      } else {
        this.form.post("/admin/api/wifi/vendors").then(() => {
          this.$buefy.toast.open({
            type: "is-success",
            message: "Successfully saved."
          });
          this.form.id = null;
          this.form.name = null;
          this.form.description = null;

          this.whenAdded();
        });
      }
    },
    whenAdded() {
      this.$router.push(`/wifi/vendors`)
    },
  }
}
</script>
